const sidebarMenu = {
    todolist: 'Daftar Tugas'
};
export default sidebarMenu;
